<template>
  <div>

    <!-- //TITLE MOBILE -->
    <div class="header mobile">
      <h1>{{general.challengeTitle}}</h1>
      <b-button class="bt-challenges"  @click="showModalMobile"  ref="btnShowMobile" >{{general.challengeBtPopupMobile}}</b-button>      
    </div>
    <!-- //TITLE MOBILE -->

    <div class="block__sidebar content__challenges">

      <!-- //TITLE DESKTOP -->
      <div class="header desktop">
        <h1>{{general.challengeTitle}}</h1>
        <b-button class="bt-challenges" @click="showModal" ref="btnShow">{{general.challengeBtPopupDesktop}}</b-button>
      </div>
      <!-- //TITLE DESKTOP -->

      <!-- //SUBTITLE DESKTOP -->
      <div class="header-sub">
          <div class="entete title nmtop">
            <p>{{general.challengeSubTitle}}</p>
          </div>        
        <b-button class="btn btn-blue">{{general.formBtSeeAll}}</b-button>
      </div>
      <!-- //SUBTITLE DESKTOP -->

      <!-- cards -->
      <b-row class="cards"  v-if="!isMobile">
        <b-col sm="12" lg='6'>
          <cardChallengesPicture
          subtitle = 'Jeu concours'
          title = 'Pura Vida'
          targetTitle = 'En cours'
          ranking = "Classement"
          rankingNumber = "82"
          rankingResult = "15"
          score = "score"
          scoreNumber = "250 000"
          target = "+1"
          />
        </b-col>

        <b-col sm="12" lg='6'>
          <cardChallengesDate
          title = 'Chiffre d’affaire AN personnalisé'
          subtitle = 'Chiffre d’affaire AN'
          startDate = '04/04/2020'
          endDate = "04/05/2020"
          objectiveNumber = "120 000"
          inprogress = "58 000"
          deadline = "60"
          state = "en cours"
          />
        </b-col>
      </b-row>

      <!-- cardChallengesCommercials -->
      <b-row class="block__cardChallengesCommercials" v-if="!isMobile">
        <b-col sm="12">
          <div class="header-sub">
              <div class="entete title">
                <p>{{general.challengeSubTitleCommercial}}</p>
              </div>        
          </div>
        </b-col>
          <b-col sm="12" lg='6' class="item">
            <cardChallengesCommercials
            title = 'Chiffre d’affaire AN personnalisé'
            subtitle = 'Chiffre d’affaire AN'
            startDate = '04/04/2020'
            endDate = "04/05/2020"
            objectiveNumber = "120 000"
            inprogress = "58 000"
            deadline = "60"
            state = "en cours"
            />
          </b-col>
          <b-col sm="12" lg='6' class="item">
            <cardChallengesCommercials
            title = 'Chiffre d’affaire AN personnalisé'
            subtitle = 'Chiffre d’affaire AN'
            startDate = '04/04/2020'
            endDate = "04/05/2020"
            objectiveNumber = "120 000"
            inprogress = "58 000"
            deadline = "60"
            state = "en cours"
            />
          </b-col>
      </b-row>      

      <!-- FORM CHALLENGE -->
      <formChallenge/>

      <!-- SIDEBAR -->
      <SidebarChallenges class="mobile"  v-if="isMobile"/>

    </div>



    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
      <transition name="slide">      
        <keep-alive>
          <router-view class="transition"></router-view>
        </keep-alive>
      </transition> 
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->    
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import cardChallengesPicture from '../../../module/card/CardChallengesPicture'
import cardChallengesDate from '../../../module/card/CardChallengesDate'
import cardChallengesCommercials from '../../../module/card/CardChallengesCommercials'
import formChallenge from '../../../module/modal/FormChallenge'
// import Navbar from '../../../module/Navbar'
import SidebarChallenges from '../../../module/sidebar/SidebarChallenges'
import utils from '../../../Utils'


export default {
  name:"challengesHome",
    components:{
      cardChallengesPicture,
      cardChallengesDate,
      cardChallengesCommercials,
      formChallenge,
      // Navbar,
      SidebarChallenges
    }, 
    computed: {
      ...mapGetters([
        'getBrowse',
        'getGeneral',
      ])
    },
    data () {
      return {
        content:"",
        formContent:"",
        general:'',
        isMobile:false,
      }
    },
    created (){
      this.content = this.getBrowse;
      this.general = this.getGeneral;
      this.isMobile = utils.isMobile();
      console.log('CREATED');
    },    
    methods : {   
      showModal() {
        console.log('SHOW MODAL');
        this.$root.$emit('bv::show::modal', 'form-challenge', '#btnShow');
      },      
      showModalMobile() {
        console.log('SHOW showModalMobile');
        this.$root.$emit('bv::show::modal', 'form-challenge', '#btnShowMobile');
      },      
    }
};
</script>
